






















import Vue from "vue";
import Lottie from "vue-lottie";
import * as help1 from "@/assets/lottie/help1.json";
import * as help2 from "@/assets/lottie/help2.json";
export default Vue.extend({
  name: "Introduction",
  components: {
    Lottie
  },
  data() {
    return {
      lottie1Options: {
        // @ts-ignore
        animationData: help1.default
      },
      lottie2Options: {
        // @ts-ignore
        animationData: help2.default
      },
      loading: false,
      mediaSize: 100
    };
  }
});
